/** @format */
import { rgba } from 'emotion-rgba';
import { css } from 'styled-components';

import { focusOutline } from '@toucan/client/global/application';

import { TabVariant } from '@toucan/client/shared/components/tab-panel/components/tab-group/components/tab';

import { TabGroupProps } from './index';

/**
 * Base styles for the TabGroup component
 */
const baseStyles = () => css`
    position: relative;
`;

const variantStyles = (props: TabGroupProps) => {
    switch (props.variant) {
        case TabVariant.INFO:
            return css`
                display: flex;
                height: fit-content;
                padding: var(--layout-spacing-8);
                background: var(--colors-surface-inverse);
                border-radius: 0.8rem;
                gap: 0.4rem;
                ${focusOutline()}
            `;
        default:
            return css`
                .tab {
                    position: relative;
                    margin-right: 3.6rem;
                    z-index: 2;

                    &:last-child {
                        margin-right: 0;
                    }
                }

                &:focus {
                    outline: 0;

                    body:not(.using-mouse) & .tab[aria-selected='true'] {
                        background: ${rgba('#0b002b', 0.2)};
                    }
                }
                display: inline-block;
            `;
    }
};

/**
 * The TabGroup component styles
 *
 * @param {TabGroupProps} props The tab-group properties object
 */
export const styles = (props: TabGroupProps) => css`
    ${baseStyles()}
    ${variantStyles(props)}
`;
